import { useAuth } from "../../auth/AuthContext";
import { Card, PageHeader } from "../../components/ui";
import { useTheme } from "../../theme/ThemeContext";

export default function ClientProfile() {
  const { clientSelf } = useAuth();
  const { firmName } = useTheme();

  const profile = clientSelf?.profile;

  return (
    <>
      <PageHeader
        title="My profile"
        subtitle="Your details as recorded by the chambers."
      />

      <div className="grid gap-6 lg:grid-cols-3">
        <Card title="Details" className="lg:col-span-2">
          {profile ? (
            <dl className="grid gap-x-8 gap-y-3 sm:grid-cols-2">
              {[
                { label: "Name", value: profile.name },
                { label: "Email (login username)", value: profile.email },
                { label: "Phone", value: profile.phone ?? "—" },
                { label: "Address", value: profile.address ?? "—" },
                {
                  label: "City / State / PIN",
                  value:
                    [profile.city, profile.state, profile.pincode].filter(Boolean).join(", ") ||
                    "—",
                },
              ].map((row) => (
                <div key={row.label}>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-muted">
                    {row.label}
                  </dt>
                  <dd className="mt-0.5 text-sm">{row.value}</dd>
                </div>
              ))}
            </dl>
          ) : (
            <p className="text-sm text-muted">Profile details are unavailable.</p>
          )}
          <p className="mt-4 border-t border-border pt-3 text-xs text-muted">
            To update your contact details, please get in touch with the chambers.
          </p>
        </Card>

        <Card title="The chambers">
          <p className="font-heading text-base font-semibold">{firmName}</p>
          <p className="mt-2 font-heading text-sm italic text-muted">
            Fiat justitia, ruat caelum.
          </p>
          <p className="mt-4 text-xs text-muted">
            This portal shows your matters and invoices. For anything urgent,
            contact your advocate directly.
          </p>
        </Card>
      </div>
    </>
  );
}
